var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abstract-dropdown',{attrs:{"items":_vm.items,"options":_vm.defaultOptions},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }